import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { m } from 'framer-motion';
import styled from 'styled-components';
import ButtonStyles from '../Button/Button.styles';
const Container = styled.div `
  position: relative;
  z-index: 10;

  &[data-active='true'] {
    > button {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  > button {
    svg {
      ${transition('transform', 0.25)}
    }
  }
`;
const FloatingCtas = styled.div `
  position: absolute;
  width: 100%;
  background-color: ${brand.primary.white};
  top: calc(100% + 10px);

  opacity: 0;
  pointer-events: none;
  ${transition('opacity', 0.25)}

  [data-active='true'] & {
    opacity: 1;
    pointer-events: all;
  }

  border-radius: 8px;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  ${ButtonStyles.Container} {
    justify-content: flex-start;
  }

  &:hover {
    ${() => Separator} {
      opacity: 0;
    }
  }
`;
const Separator = styled.div `
  width: 80%;
  margin: 0 auto;
  height: 1px;
  background-color: ${brand.grey.base};
`;
const MobileButton = styled.button `
  ${ButtonReset};
  display: flex;
  gap: 8px;
  cursor: pointer;

  svg {
    width: 24px;
    height: 100%;
    color: ${brand.primary.brightBlue};

    [data-active='true'] & {
      transform: rotate(180deg);
    }

    ${transition('transform', '200ms', 'cubic-bezier(.165,.84,.44,1)')};
  }

  ${fonts.ubuntu.regular};
  font-size: 20px;
  line-height: 24px;
  color: ${brand.primary.darkBlue};
`;
const Collapse = styled(m.div).attrs((props) => ({
    initial: 'collapsed',
    animate: props['data-active'] ? 'expanded' : 'collapsed',
    variants: {
        collapsed: {
            height: '0px',
        },
        expanded: {
            height: 'auto',
        },
    },
})) `
  overflow: hidden;
`;
const CollapseInner = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px 0px 0px 10px;
`;
export const SplitButtonStyles = {
    Container,
    FloatingCtas,
    Separator,
    MobileButton,
    Collapse,
    CollapseInner,
};
